<div class="toolbar">
    <h3>Rent Comparables</h3>
    <div class="tools">
        <button class="btn" (click)="exportToXlsx()">Export</button>
    </div>
</div>

<ag-grid-angular class="ag-theme-alpine grid" [rowData]="rows$ | async" [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef" [animateRows]="true" [rowSelection]="'multiple'" 
    [masterDetail]="true" [detailCellRendererParams]="detailCellRendererParams"
    [suppressMenuHide]="true" (gridReady)="onGridReady($event)">
</ag-grid-angular>